import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

class Email extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            value: '',
            touched: false
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data && nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {};
        if (nextData && nextData[nextProps.control.key] === undefined && prevState.touched) {
            return {
                value: '',
                touched: false
            };
        }
        else if (nextData) {
            return {
                value: nextData[nextProps.control.key]
            };
        }
        else return null; // Triggers no change in the state
    }
    componentDidMount() {
        this.setState({ touched: this.state.value ? true : false });
        ControlService().controlVaildationCheck(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value && this.state.value === undefined && this.state.touched === false) {
            this.props.update(this.props.control.key, this.state.value, this.props.formid)
        } else if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    onValueChange(value, control, action, formid) {
        if (this.props.action == 'filter') {
            this.props.updateFilter(this.props.control.key, value)
        }
        else {
            this.props.update(this.props.control.key, value, this.props.formid)
        }

        var validation = ControlService().validate(control, value);
        var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
        if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }

    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    confirmEmail(control, formid) {
        let _confirmEmail = false;
        if (control.confirmemail) {
            var data = this.props.data[formid] ? this.props.data[formid] : {};
            if (control.confirmwithcontrol && data[control.confirmwithcontrol] && data[control.confirmwithcontrol] != this.state.value) {
                _confirmEmail = true;
            }
        }
        return _confirmEmail;
    }
    shouldMarkError(control) {
        const validate = ControlService().validate(control, this.state.value);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {

        const { control, action, formid } = this.props;
        // var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control);
        if (action == 'write') {
            return (
                <div className="form-group">
                    {control.label &&
                        <label htmlFor={control.id}>
                            {control.label}
                            {control.require &&
                                <sup className="text-danger font-weight-bold">*</sup>
                            }
                            {control.showhelptext &&
                                <span className={"custom-tooltip"}>
                                    <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                    <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                </span>
                            }
                        </label>
                    }
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fa fa-envelope-o"></i></span>
                        </div>
                        <input
                            aria-label={control.label}
                            type="email"
                            id={control.id}
                            className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                            onBlur={() => { this.handleBlur(); }}
                            placeholder={control.placeholder}
                            onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                            value={this.state.value}
                            disabled={this.props.disabled}
                        />
                    </div>
                    {shouldMarkError && !this.state.value ?
                        <small className="form-text text-danger">
                            {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                        </small>
                        : null
                    }
                    {shouldMarkError && this.state.value && !this.state.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ?
                        <small className="form-text text-danger" >
                            You must include a valid email address.
                        </small>
                        : null
                    }
                    {(this.state.value && this.confirmEmail(control, formid)) &&
                        <small className="form-text text-danger" >
                            {control.confirmemailmsg ? control.confirmemailmsg : 'Email not match.'}
                        </small>
                    }
                </div>
            );
        } else {
            return (
                <div style={{ marginHorizontal: 10, marginBottom: 10 }}>
                    <label style={{ fontSize: 13 }}>{control.label}</label>
                    <div style={{ paddingLeft: 30, fontWeight: 'bold' }}>{this.props.editformdata[control.key]}</div>
                </div>
            );
        }
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(Email);